import { BASE_URL } from "../../Constants";
import axios from "axios";

export const all_ads = async () => {
  let url = `${BASE_URL}/api/adsections`;
  const res = await axios.get(url);
  return res;
};
